import React, { useState } from "react";
import { Search } from "lucide-react";

const ContactList = ({ conversations, activeConversationId, onSelectConversation }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredConversations = conversations.filter((conv) =>
    conv.creatorName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="flex flex-col h-full bg-slate-50/50 border-r border-slate-200 w-full @md:w-80">
      <div className="p-4 border-b border-slate-200 bg-white">
        <h2 className="text-lg font-bold text-slate-800 mb-3 px-1">Inbox</h2>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={16} />
          <input
            type="text"
            placeholder="Search conversations..."
            className="w-full pl-9 pr-4 py-2 bg-slate-100 border-none rounded-lg text-sm focus:ring-2 focus:ring-purple-500/20 focus:bg-white transition-all placeholder:text-slate-400"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        {filteredConversations.map((conv) => (
          <div
            key={conv.id}
            onClick={() => onSelectConversation(conv.id)}
            className={`group flex items-start p-4 cursor-pointer transition-all border-b border-slate-50 hover:bg-white ${
              activeConversationId === conv.id ? "bg-white border-l-4 border-l-purple-600 shadow-sm z-10" : "border-l-4 border-l-transparent"
            }`}
          >
            <div className="relative shrink-0">
              <img
                src={conv.creatorProfilePictureUrl}
                alt={conv.creatorName}
                className="w-10 h-10 rounded-full object-cover ring-2 ring-white"
              />
              {!conv.isRead && (
                <span className="absolute -top-1 -right-1 w-3 h-3 bg-purple-600 border-2 border-white rounded-full"></span>
              )}
            </div>
            <div className="ml-3 flex-1 min-w-0">
              <div className="flex justify-between items-baseline mb-0.5">
                <h4 className={`text-sm truncate ${!conv.isRead || activeConversationId === conv.id ? "font-bold text-slate-900" : "font-medium text-slate-700"}`}>
                  {conv.creatorName}
                </h4>
                <span className="text-[10px] text-slate-400 font-medium">{conv.lastMessageTimestamp}</span>
              </div>
              <p className={`text-xs truncate ${!conv.isRead ? "text-slate-800 font-medium" : "text-slate-500 group-hover:text-slate-600"}`}>
                {conv.lastMessage}
              </p>
            </div>
          </div>
        ))}
        {filteredConversations.length === 0 && (
            <div className="p-8 text-center text-slate-400 text-sm">
                No matching conversations found.
            </div>
        )}
      </div>
    </div>
  );
};

export default ContactList;
